// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__1JDlm","content":"Consent_content__1Cpry","footer":"Consent_footer__2HIZL"};